<script>
	import { createEventDispatcher } from 'svelte';
    import { ChevronDownIcon } from '@rgossiaux/svelte-heroicons/solid';
    import { onMount } from 'svelte';

    let sort_dropdown = false;
	let sort_menu     = null;
	let selectedOption;
	export let menulist = [];
    export let title;

	const dispatch = createEventDispatcher();

	function selectOption(menu) {
        sort_dropdown = false;
		dispatch('select', {
			option: menu
		});
		selectedOption.innerText = menu
	}

    onMount(() => {
		const handle_outside = (e) => {
			if(sort_dropdown && !sort_menu.contains(e.target)){
				sort_dropdown = false;
			}
		}
		document.addEventListener('click', handle_outside, false);

		return () => {
			document.removeEventListener('click', handle_outside, false);
		}
	});
</script>

<div bind:this={sort_menu} class="dropdown_container">
    <button class="selection" on:click={() => sort_dropdown = !sort_dropdown}>
        <span bind:this={selectedOption}>{title}</span>
        <ChevronDownIcon color="#fff" height="20" width="20"/>
    </button>

    {#if sort_dropdown}
        <div class="dropdown">
            {#each menulist as menu}
                <button on:click={selectOption(menu)} class="dropdown_contents">
                    {menu}
                </button>
            {/each}
        </div>
    {/if}
</div>
<style>
    .dropdown_contents{
		color: #fff;
		width: 150px;
		text-align: left;
		border: none;
		cursor: pointer;
		background-color: #232430;
		z-index: 997;
	}
	.dropdown_contents:hover{
		opacity: 0.5;
	}
	.dropdown_container{
		position: relative;
		z-index: 1;
	}
	.dropdown{
		position: absolute;
		background-color: #232430;
		width: 150px;
		text-align: center;
		border: #fff;
		box-shadow: 0 4px 4px 0 #000;
		z-index: 995;
	}
    .selection{
        width: auto;
        height: 45px;
        font-size: 0.9rem;
        flex-grow: 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 10px;
        padding: 10px 15px;
        border-style: solid;
        border-width: 3px;
        border-image-source: linear-gradient(134deg, #9c0ccf 0%, #5157d4 100%);
        border-image-slice: 1;
        color: #fff;
        background-color: #1e1e1e;
        cursor: pointer;
		z-index: 998;
    }
</style>